@let blok = responsiveBlok();
@let currentTariff = tariffStore.tariff$();
@let currentSize = tariffStore.size$();

<!-- to change detect on price changes -->
@let prices = tariffStore.tariffPricesFamily$();
@if(false) {
    <span>{{ prices }}</span>
}

<ng-template let-size="size" #sizeHeader>
    <div [class]="baseClass + '--size-header-wrapper ' + 'pb-2 md:pb-0'"
         class="z-10 bg-white !rounded-none md:!rounded-t-lg"
         [class.md:bg-accent]="size === blok.topsellerTariff">
        <!-- topseller -->
        @if (size === blok.topsellerTariff) {
            <div
                class="bg-accent rounded-t-lg max-[340px]:text-xs text-sm sm:text-base text-center max-[340px]:p-[12px] p-[10px] sm:p-[8px]"
                [class]="baseClass + '--topseller-header'">
                {{ blok.topsellerText }}
            </div>
        }
        @if (((size | indexToTariffEntry:blok.secondaryBannerTextBasic:blok.secondaryBannerTextComfort:blok.secondaryBannerTextPremium)?.length || 0) > 0) {
            <div class="bg-grey90 rounded-t-lg text-center text-sm sm:text-base p-1 hidden md:block"
                 [class]="baseClass + '--secondary-banner-header'">
                {{ size | indexToTariffEntry:blok.secondaryBannerTextBasic:blok.secondaryBannerTextComfort:blok.secondaryBannerTextPremium }}
            </div>
        }
        <button [class]="baseClass + '--size-header'"
                [class.is-selected]="size === tariffStore.size$()"
                [class.is-topseller]="size === blok.topsellerTariff"
                [class.rounded-tl-lg]="size === 'basic'"
                [class.rounded-tr-lg]="size === 'premium'"
                [class.md:rounded-t-lg]="size !== blok.topsellerTariff && !(size | indexToTariffEntry:blok.secondaryBannerTextBasic:blok.secondaryBannerTextComfort:blok.secondaryBannerTextPremium)?.length"
                class="text-center bg-primary10 p-4 block w-full md:rounded-none"
                (click)="tariffStore.selectSize(size)"
                [tabindex]="-1">
            <h3 class="text-inherit text-lg sm:text-2xl md:text-4xl font-light mb-4 md:mb-6 app-ellipsis">
                {{ size | indexToTariffEntry: blok.basicText : blok.comfortText : blok.premiumText }}
            </h3>
            <h4 class="text-inherit text-xl sm:text-3xl md:text-5xl mb-1 app-ellipsis">
                {{ size | tariffPrice: currentTariff }}
            </h4>
            <p class="text-sm sm:text-lg text-light app-ellipsis">
                im Monat
            </p>
            <a app-tariff-size-button
               (click)="selectTariff($event, tariffStore.tariff, tariffStore.size)"
               [routerLink]="(currentTariff === 'family' ? (size | indexToTariffEntry:blok.linkFamilyBasic?.cached_url:blok.linkFamilyComfort?.cached_url:blok.linkFamilyPremium?.cached_url) : (size | indexToTariffEntry:blok.linkSingleBasic?.cached_url:blok.linkSingleComfort?.cached_url:blok.linkSinglePremium?.cached_url)) | sbRouterLink | cachedUrlResolver"
               class="hidden md:flex"
               [priceContent]="size | tariffPrice: currentTariff"
               [topsellerText]="blok.topsellerText"
               [topsellerTariff]="blok.topsellerTariff"
               [tariffSize]="size"
               [disabled]="!currentTariff || !currentSize">
                {{ !currentTariff || !currentSize ? blok.makeSelectionText : blok.selectText }}
            </a>
        </button>
    </div>
</ng-template>
@if ((blok.appearance || '3-columns') === '3-columns') {
    <div [class]="baseClass + '--selection-mobile'"
         [class.hidden]="!currentTariff"
         class="md:hidden">
        @for (index of [0, 1, 2]; track index) {
            <a app-tariff-size-button
               (click)="selectTariff($event, tariffStore.tariff, tariffStore.size)"
               [routerLink]="(currentTariff === 'family' ? (index | indexToTariffEntry:blok.linkFamilyBasic?.cached_url:blok.linkFamilyComfort?.cached_url:blok.linkFamilyPremium?.cached_url) : (index | indexToTariffEntry:blok.linkSingleBasic?.cached_url:blok.linkSingleComfort?.cached_url:blok.linkSinglePremium?.cached_url)) | sbRouterLink | cachedUrlResolver"
               [disabled]="!currentTariff || !currentSize"
               [priceContent]="(index | indexToTariffSize) | tariffPrice: currentTariff"
               [topsellerText]="blok.topsellerText"
               [topsellerTariff]="blok.topsellerTariff"
               [tariffSize]="index | indexToTariffSize">
                {{ index | indexToTariffEntry:blok.chooseBasic:blok.chooseComfort:blok.choosePremium }}
            </a>
        }
    </div>
}
<div [class]="baseClass + '--size-header'"
     class="hidden"
     [class.md:block]="blok.appearance === '4-columns'">
</div>
@for (index of [0, 1, 2]; track index) {
    <ng-container *ngTemplateOutlet="sizeHeader;context:{size: index | indexToTariffSize}">
    </ng-container>
}
<!-- special sections for 3-column desktop -->
@if ((blok.appearance || '3-columns') === '3-columns') {
    @for (index of [0, 1, 2]; track index) {
        <div [class]="baseClass + '--section-column'"
             [class.is-selected]="(index | indexToTariffSize) === currentSize"
             [class.is-topseller]="(index | indexToTariffSize) === blok.topsellerTariff"
             class="bg-primary10 hidden md:block gap-x-2 pb-8 rounded-b">
            @for (child of $any(blok.sections) | filterTariffSectionForSize: (index | indexToTariffSize); track child['_uid']; let i = $index) {
                <div class="bg-primary10 md:bg-transparent">
                    <app-tariff-section [block]="child"
                                        [size]="index | indexToTariffSize"
                                        [appearance]="blok.appearance || '3-columns'"
                                        [tariff]="currentTariff"
                                        [selectedIcon]="blok.selectedIcon!"
                                        [selectedIconActive]="blok.selectedIconActive!"
                                        [unselectedIcon]="blok.unselectedIcon!"
                                        [topsellerTariff]="blok.topsellerTariff"
                                        [topsellerText]="blok.topsellerText" />
                </div>
            }
        </div>
    }
}
<!-- default sections for 3-column mobile and 4-column -->
@for (child of blok.sections; track child['_uid']; let i = $index) {
    <div [class]="baseClass + '--section'"
         class="bg-primary10 md:bg-transparent"
         [class.md:hidden]="(blok.appearance || '3-columns') === '3-columns'">

        <app-tariff-section [block]="child"
                            [appearance]="blok.appearance || '3-columns'"
                            [tariff]="currentTariff"
                            [selectedIcon]="blok.selectedIcon!"
                            [selectedIconActive]="blok.selectedIconActive!"
                            [unselectedIcon]="blok.unselectedIcon!"
                            [topsellerTariff]="blok.topsellerTariff"
                            [topsellerText]="blok.topsellerText" />
    </div>
}
